import WebSocket from "isomorphic-ws"
import eventBus from '../../plugins/eventBus'
import { v4 as uuid } from 'uuid'
import Cookies from "js-cookie"
import store from '@/store/main.js';

const user = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : {}
const tenant = Cookies.get('tenant') ? JSON.parse(Cookies.get('tenant')) : {}
const uuidInit = uuid.v4()

const state = () => ({
  websocket: null,
  uuid: ""
});

// getters
const getters = {
  getWebsocket(state) {
    return state.websocket;
  }
};

// actions
const actions = {
  async initWebsocket({ commit }, channel = null) {

    const ws = await new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL)
    ws.onopen = () => {
      // no data open for tenants
      if (!channel) {

        ws.send(JSON.stringify({
          data: {
            client_id: uuidInit,
            user_id: user.id,
            tenant_id: tenant.id,
            merchant_id: tenant.merchant
          },
          event: "subscribe"
        }))
      } else {
        ws.send(JSON.stringify({
          data: {
            client_id: channel,
            user_id: user.id || '',
            tenant_id: tenant.id || '',
            merchant_id: tenant.merchant || ''
          },
          event: "subscribe"
        }))
      }
      // websocket send message websocket
      eventBus.on('sendMessageWebscocket', payload => {
        const {event, data} = payload
        ws.send(JSON.stringify({
          data: {
            client_id: data.client_id
          },
          event: event
        }))

        eventBus.off('sendMessageWebscocket', payload)
      })
    }

    ws.onmessage = e => {

      const {data, event} = JSON.parse(e.data)
      let tenatnsId = data.tenant_id || ''
      let userId = data.user_id || ''
      switch (event) {
        case 'order.running.number':
          if (data.data.tenant_id == tenant.id) {
            const orders = data.data.orders
            orders.map(order => {
              const elementId = `order-number-${order.id}`
              document.querySelectorAll(`[id="${elementId}"]`).forEach(element => {
                const prevElement = element.previousElementSibling
                if (prevElement) {
                  prevElement.remove()
                }
                element.innerHTML = order.order_number
                element.style.display = 'inline-block'
              })
            })
            eventBus.emit('updateOrderNumber', orders)
          }
          break
        case 'request.wallet.shipment':
          if (data.data.tenant_id == tenant.id) {
            let tenantStore = {
              ...tenant,
              wallet_shipment: data.data.wallet_shipment
            }
            store.dispatch("user/getTenant", tenantStore);
          }
          break
        case 'request.tracking':
          if (userId == user.id && tenatnsId == tenant.id) {
            eventBus.emit('requestTracking', data)
          }
          break
        case 'request.printshippinglabel':
          if (userId == user.id && tenatnsId == tenant.id) {
            store.dispatch("shipment/listDataPrint", data);
          }
          break
        case 'shipment.incomming':
          if (data.tenant_id == tenant.id) {
            store.dispatch("shipment/dataIncomming", data);
          }
          break
        case 'shipment.updated':
          if (tenatnsId == tenant.id) {
            store.dispatch("shipment/dataUpdated", data);
          }
          break
        case 'order.incomming':
          if (data.tenant_id == tenant.id) {
            store.dispatch("order/dataIncomming", data);
          }
          break
        case 'order.updated':
          if (tenatnsId == tenant.id) {
            store.dispatch("order/dataUpdated", data);
          }
        case 'permission.update':
          if (userId == user.id && tenatnsId == tenant.id) {
            Cookies.set('wmsServicePermission', JSON.stringify(data.wms_service_permission), { domain: '.' + process.env.CENTRAL_API_ROOT });
          }
          break
        case 'ping':
          if (user.id && tenant.id) {
            ws.send(JSON.stringify({
              data: {
                client_id: uuidInit,
                user_id: user.id || '',
                tenant_id: tenant.id || '',
                merchant_id: tenant.merchant || ''
              },
              event: "pong"
            }))
          }
          break
        case 'CreateStore':
          eventBus.emit('CreateStore', data)
          break
        case 'UpgradeStore':
          eventBus.emit('UpgradeStore', data)
          break
        case 'request.notificationUnread':
          if (userId == user.id && tenatnsId == tenant.id) {
            store.dispatch("user/unRead", data);
          }
        break
        case 'payment.status':
          if (userId == user.global_id && tenatnsId == tenant.id) {
            eventBus.emit('updatePlan', data)
          }
          break
      }

    }

    ws.onclose = (event) => {
      console.log("The connection has been closed. waiting retry in 5 seconds.");
      setTimeout(() => store.dispatch('websocket/initWebsocket'), 500)
    };

    commit("setWebsocket", ws);
    commit("setUuid", uuidInit);
  }
};

// mutations
const mutations = {
  setWebsocket(state, payload) {
    state.websocket = payload;
  },
  setUuid(state, payload) {
    state.uuid = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/websocket.js